import { render, staticRenderFns } from "./mouseColorful.vue?vue&type=template&id=4de892fd"
import script from "./mouseColorful.vue?vue&type=script&lang=js"
export * from "./mouseColorful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports